import "./Logo.css";

export default function Logo({ compact = false }) {
  return (
    <div className={`logo-container ${compact ? "compact" : ""}`}>
      <div className="logo-wrapper">
        <div className="logo-circle">
          <div className="logo-pivot">P</div>
        </div>
      </div>
      {!compact && <div className="logo-text">SelfPivot</div>}
    </div>
  );
}
